module.exports = __webpack_public_path__ + "img/empty.29d3e9c7.svg";